<app-base-template (modal)="openModal(content)" (searchmodal)="searchModal()" (dataExportToExcel)="exportToExcel()"
  (tabledata)="getTableData()" [displayData]="displayData" [nextOffset]="nextOffset" [previousOffset]="previousOffset"
  (offset)="getData($event)" (pageSize)="onPageSizeChange($event)" [pageNo]="page_no" [totalPage]="totalPage"
  [showExportBtn]="showExportBtn" [showSearch]="showSearch" [dataLoaded]="dataLoaded"></app-base-template>
<ng-template #content let-c="close" let-d="dismiss">
  <div class="loader" [hidden]="dataLoaded"><img class="loading-gif" src="../../../assets/img/loader.gif"></div>

  <div class="modal-header modalTitle">
    <div class="modal-title">Ticket Configuration</div>
  </div>

  <div class="modal-body">
    <div class="none" [ngClass]="{'inputError':isError}">{{errorMessage}}</div>
    <div class="form-group">
      <mat-radio-group (change)="onButtonChange($event)">
        <div *ngFor="let button of types;">
          <mat-radio-button [value]="button.id" [checked]="button.checked">{{button.name}}</mat-radio-button>
        </div>
      </mat-radio-group>
    </div>
    <div class="form-group">
      <select class="custom-select mr-sm-2 radius-0 font-13" [(ngModel)]="fieldSelected"
        (change)="onFieldChange($event.target.selectedIndex)">
        <option *ngFor="let field of fields" [value]="field.id">{{field.name}}</option>
      </select>
    </div>
    <div class="form-group ticket-menu">
      <!--<select class="custom-select mr-sm-2 radius-0 font-13" [(ngModel)]="fieldValueSelected"-->
      <!--(change)="onFieldValueChange($event.target.selectedIndex)">-->
      <!--<option *ngFor="let fieldValue of fieldValues" [value]="fieldValue.id">{{fieldValue.name}}</option>-->
      <!--</select>-->
      <mat-checkbox class="font-13" *ngFor="let fieldValue of fieldValues" value="{{fieldValue.id}}"
        [(ngModel)]="fieldValue.checked">{{fieldValue.name}}&nbsp;&nbsp;&nbsp;&nbsp;</mat-checkbox>
    </div>



    <div class="form-group">
      <mat-radio-group (change)="onRadioButtonChange($event)" class="font-13">
        <mat-radio-button [value]="1">&nbsp;All Users &nbsp;&nbsp;</mat-radio-button>
        <mat-radio-button [value]="2">&nbsp;Manually Select &nbsp;&nbsp;</mat-radio-button>
      </mat-radio-group>
    </div>

    <!-- <div class="form-group" *ngIf="this.radioChecked === 1 || this.radioChecked === '1' ">
      <mat-form-field>
        <mat-label>Group level Filter</mat-label>
        <mat-select [(ngModel)]="selectedGroupFilter" multiple (selectionChange)="onGroupFilterChange(selectedGroupFilter)">
          <mat-option *ngFor="let group of groupFilter" [value]="group.id">{{group.name}}</mat-option>
        </mat-select>
      </mat-form-field>
    </div> -->

    <div class="form-group" *ngIf="this.radioChecked === 1 || this.radioChecked === '1' ">
      <mat-form-field style="width: 100%;">
        <mat-label>Select Support Groups</mat-label>
        <mat-select [(ngModel)]="groupSelectedArr" multiple (selectionChange)="onGroupChange1(groupSelectedArr)">
          <mat-option *ngFor="let group of groups" [value]="group.id">{{group.name}}</mat-option>
        </mat-select>
      </mat-form-field>
    </div>

    <div class="form-group" *ngIf="this.radioChecked === 2 || this.radioChecked === '2' ">
      <select class="custom-select mr-sm-2 radius-0 font-13" [(ngModel)]="groupSelected"
        (change)="onGroupChange($event.target.selectedIndex)">
        <option *ngFor="let group of groups" [value]="group.id">{{group.name}}</option>
      </select>
    </div>

    <div class="form-group ticket-menu" *ngIf="this.radioChecked === 2 || this.radioChecked === '2'">
      <mat-form-field style="width: 100%;">
        <mat-label>Select Users</mat-label>
        <mat-select [(ngModel)]="userSelected" multiple>
          <mat-option *ngFor="let group of users" [value]="group.id">{{group.name}}</mat-option>
        </mat-select>
      </mat-form-field>
    </div>
  </div>

  <div class="modal-footer pad-8">
    <button type="button" class="btn btn-success radius-0" (click)="save()">Save</button>
    <button type="button" class="btn btn-danger radius-0" (click)="c()">Cancel</button>
  </div>
</ng-template>


<ng-template #scarch_content let-c="close" let-d="dismiss">
  <div class="modal-header modalTitle">
    <div class="modal-title">Search</div>

  </div>
  <div class="modal-body">
    <div class="form-group mar_top">
      <input type="text" class="form-control radius-0 font-13" placeholder=" Enter Support Group"
        [(ngModel)]="sgrpSelected">
    </div>
  </div>
  <div class="modal-footer pad-8">
    <button type="button" class="btn btn-success float-right radius-0" (click)="search()">search</button>
    <button type="button" class="btn btn-danger radius-0" (click)="c()">Cancel</button>
  </div>

</ng-template>
<notifier-container></notifier-container>